var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetBall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a9da48ed-3b4c-42e8-9b58-266d5058c4c0",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "vbl") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.76,92.55l0-.08A40.32,40.32,0,1,0,75,102.89h.21v0A40.54,40.54,0,0,0,92.63,92.58ZM40.51,93h0c0-.08-3.41-7.87,5.17-21.51l-2.54-1.59c-5.57,8.85-6.52,15.54-6.31,19.66a37.61,37.61,0,0,1-8-13.11h.05A31.19,31.19,0,0,1,39.29,55.34l-2-2.26A33.43,33.43,0,0,0,27.13,69.39a36.87,36.87,0,0,1-.4-5.39A37.39,37.39,0,0,1,44.24,32.36c1.39,1.44,6.28,7.21,9.57,19.86l2.9-.76C53.58,39.4,49,33.17,46.91,30.83a37.12,37.12,0,0,1,15-4.14v0s2.88,1.36,5.64,6.06c2.6,4.42,5.64,12.76,5.39,27.38l3,.05c.34-20.18-5.29-29.48-9.21-33.49a37.19,37.19,0,0,1,20,7.54c3.45,5.88,4.17,12.35,4.17,20.23h3a52.78,52.78,0,0,0-1.73-15.16,37.32,37.32,0,0,1,7,37.81,73.12,73.12,0,0,1-19.88-5.34l-1.15,2.77A76.76,76.76,0,0,0,97.89,80a37.71,37.71,0,0,1-6.72,9.76c-3.1.35-14.33.63-31.21-10.12l-1.61,2.53C72,90.9,82.2,92.72,87.81,92.89a37,37,0,0,1-13.3,7c-5.61.22-13.92-3-19.39-6.31l-1.57,2.56a53.43,53.43,0,0,0,11.57,5.21l-1,0A37.2,37.2,0,0,1,40.51,93Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetBall);
export default __webpack_public_path__ + "static/media/set-ball.9065325ce98905586d46a7e6ff5c3d47.svg";
export { ForwardRef as ReactComponent };